<template>
    <v-main>
        <keep-alive :max="2" include="ProductList,StoreList">
            <router-view :key="key" style="min-height: calc(100vh - 96px);"></router-view>
        </keep-alive>
    </v-main>
</template>

<script>
export default {
    computed: {
        key() {
            // NOTE: PAGE WITH THE SAME KEY WILL NOT BE AFFECTED BY KEEP-ALIVE (KEEP-ALIVE WILL CONSIDER SAME-KEY AS SAME-PAGE)
            let key = this.$route.fullPath;
            let keyNoQuery = this.$route.path;
            if (key.indexOf('/mystore') != -1) return '/mystore';
            if (key.indexOf('/admin') != -1) return '/admin';
            if (key.indexOf('/stores/s') != -1) return keyNoQuery;
            return key;
        }
    },
};
</script>

<style>
</style>